export const oxxioTextLinkColors = {
  // High emphasis variant
  textLinkHighEmphasisDefaultTextColor: '{{ linkColors.linkHighEmphasis }}',
  textLinkHighEmphasisHoverTextColor: '{{ linkColors.linkHighEmphasis }}',
  textLinkHighEmphasisFocusTextColor: '{{ linkColors.linkHighEmphasis }}',
  textLinkHighEmphasisDefaultUnderlineColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisHoverUnderlineColor: '{{ linkColors.linkHighEmphasis }}',
  textLinkHighEmphasisFocusUnderlineColor: '{{ linkColors.linkBrand }}',
};
